import {Directive, HostListener} from '@angular/core';

/**
 * A directive to prevent any non-digit input in a number field.
 */
@Directive({
  selector: '[appOnlyNumber]',
})
export class OnlyNumberDirective {

  @HostListener('keydown', ['$event']) onKeyDown(e: KeyboardEvent) {
    if (['Delete', 'Backspace', 'Tab', 'Escape', 'Enter', 'Home', 'End', 'ArrowLeft', 'ArrowRight'].indexOf(e.key) !== -1
      || (e.key === 'a' && (e.ctrlKey || e.metaKey))  // Allow: Ctrl+A
      || (e.key === 'c' && (e.ctrlKey || e.metaKey))  // Allow: Ctrl+C
      || (e.key === 'v' && (e.ctrlKey || e.metaKey))  // Allow: Ctrl+V
      || (e.key === 'x' && (e.ctrlKey || e.metaKey))  // Allow: Ctrl+X
      || (e.key === 'k' && e.ctrlKey)  // Allow: Ctrl+K
      || (e.key === 'e' && e.ctrlKey)  // Allow: Ctrl+E
      || (e.key === 'd' && e.ctrlKey)  // Allow: Ctrl+D
    ) {
      return;
    }
    if (e.shiftKey || e.key < '0' || e.key > '9') {
      e.preventDefault();
    }
  }
}
